'use strict';

import { FP } from './fp';
import { createCookie, getCookie, getDomain, getSearchParams, sendFetch, stringToUuid, base64_encode, ipValidation, appendInputToContactForm } from './site';

export async function setupPrint(fpsDomain = "", printPublicKey = "") {
  if(typeof document === "undefined") return;
  if(fpsDomain === "") return;
  if(printPublicKey === "") return;
  let geo1, geo2 = {};

  let fpResult = {};

  if((fpsDomain || "") !== "") {
    const promise = import(`https://fpjscdn.net/v3/${printPublicKey}`)
      .then(n => n.load({
        endpoint: `https://${fpsDomain}`,
        tlsEndpoint: 'https://use1.fptls.com',
      }));

    const fp = await promise;
    fpResult = await fp.get({
      extendedResult: true
    });
  }

  geo1 = ((fpResult)
    && (typeof fpResult === 'object')
    && ('requestId' in fpResult)
  ) ? JSON.parse(JSON.stringify(fpResult)) : {};

  const data = {
    vFingerprintOne: "",
    vFingerprintTwo: "",
    vFP1Test: getCookie("VFP1_SSID"),
    vFP2Test: getCookie("VFP2_SSID"),
    wvDomainName: getDomain(),
    wvURIPath: window.location.pathname,
    wvURL: window.location.href,
    wvToPhoneNum: "",
    wvPhoneNums: "",
    wvIsHuman: "",
    wvIsIncognito: "",
    wvDeviceType: (screen && !!screen.width && (screen.width <= 480)) ? "Mobile" : "Desktop",
    wvBrowser: "",
    wvOS: "",
    wvIPAddress: "",
    wvLatitude: "",
    wvLongitude: "",
    wvCity: "",
    wvContinentCode: "",
    wvContinentName: "",
    wvCountryCode: "",
    wvCountryName: "",
    wvDMACode: "",
    wvRegion: "",
    wvRegionCode: "",
    wvRegionName: "",
    wvTimezone: "",
    src: "",
    at: "",
    adg: "",
    oloc: "",
    gclid: "",
    wbraid: "",
    gbraid: "",
    olat: "",
    olong: "",
    wvUA: "",
    wvSWI: "",
    wvSHE: "",
  }

  try {
    data.wvUA = window.navigator.userAgent;
  } catch(e) {
    e = null;
  }

  try {
    data.wvSWI = window.innerWidth;
  } catch(e) {
    e = null;
  }

  try {
    data.wvSHE = window.innerHeight;
  } catch(e) {
    e = null;
  }

  data.wvIPAddress = data.wvIPAddress === "" && geo1.hasOwnProperty("ip") && !!geo1.ip ? geo1.ip : data.wvIPAddress ;

  if(!!data.wvIPAddress) {
    try {
      const opIPAddress = document.querySelectorAll(".Current_Location_IP_Address");
      if (opIPAddress && opIPAddress.length > 0 && opIPAddress[0]) {
        data.wvIPAddress = opIPAddress[0].value;
      }
    } catch(e) {
      e = null;
    }
  }

  let cfIPV6 = "" ;
  const {isIPV4, isIPV6} = ipValidation(data?.wvIPAddress ?? "")

  if(data.wvIPAddress === "" || isIPV4) {
      // https://stackoverflow.com/a/35123097
      const cfURL = new URL('https://www.cloudflare.com/cdn-cgi/trace');
      const cfResponse = await fetch(cfURL.toString())
        .then(response => response.text()).catch(err => {
          return err.error
        })
      if(!!cfResponse) {
        const cfData = cfResponse.trim().split('\n').reduce(function(obj, pair) {
          pair = pair.split('=');
          return obj[pair[0]] = pair[1], obj;
        }, {});
        cfIPV6 = typeof cfData === "object" && "ip" in cfData ? cfData['ip'] : '';
      }
  }


  if(data.vFP1Test === "") {
    const withCanvasDrawing = new FP({canvas: true});
    const withCanvasDrawingInput = withCanvasDrawing.get().toString();
    data.vFingerprintOne = stringToUuid(withCanvasDrawingInput);
  }

  data.vFingerprintOne = data.vFingerprintOne === "" && !!data.vFP1Test ? data.vFP1Test : data.vFingerprintOne

  if(!!data.vFingerprintOne) {
    createCookie('VFP1_SSID',data.vFingerprintOne,2);
  }

  data.vFingerprintTwo = typeof geo1 === "object" && 'visitorId' in geo1 ? geo1.visitorId : data.vFingerprintTwo;

  data.vFingerprintTwo = data.vFingerprintTwo === "" && !!data?.vFP2Test ? data?.vFP2Test : data.vFingerprintTwo;

  if(!!data.vFingerprintTwo) {
    createCookie('VFP2_SSID',data.vFingerprintTwo,2);
  }

  try {
    const phones = document.querySelectorAll(".location_phone_number");
    if (phones && phones.length > 0 && phones[0]) {
      const anchors = phones[0].querySelectorAll("a");
      if (anchors && anchors.length > 0 && anchors[0]) {
        data.wvToPhoneNum = anchors[0].innerHTML;
      }
    }
  } catch(e) {
    e = null;
  }

  try {
    const phonesArray = []
    const phoneSelect = document.querySelector("#Locations_Dropdown");
    if (phoneSelect && phoneSelect.length > 0) {
      for(let i = 0; i < phoneSelect.options.length; i++) {
        phonesArray.push((phoneSelect.options[i]?.value || "").replace(/\D/g,''));
      }
    }
    if(phonesArray?.length > 0) {
      data.wvPhoneNums = phonesArray.join('|')
    }
  } catch(e) {
    e = null;
  }

  try {
    const params = getSearchParams();
    if(typeof params === "object" && Object.keys(params)?.length > 0) {
      data.src = ( 'src' in params && !!params.src ) ? params.src : '';
      data.at = ( 'at' in params && !!params.at ) ? params.at : '';
      data.adg = ( 'adg' in params && !!params.adg ) ? params.adg : '';
      data.oloc = ( 'oloc' in params && !!params.oloc ) ? params.oloc : '';
      data.gclid = ( 'gclid' in params && !!params.gclid ) ? params.gclid : '';
      data.wbraid = ( 'wbraid' in params && !!params.wbraid ) ? params.wbraid : '';
      data.gbraid = ( 'gbraid' in params && !!params.gbraid ) ? params.gbraid : '';
      data.olat = ( 'olat' in params && !!params.olat ) ? params.olat : '';
      data.olong = ( 'olong' in params && !!params.olong ) ? params.olong : '';
    }
  } catch(e) {
    e = null;
  }

  const geoIP2URL = new URL('https://us-central1-utilities-558.cloudfunctions.net/geo_ip_2');
  geoIP2URL.searchParams.set('key', "i2dmSm_ybGpdREoNdjLTMDPmeAC7tw8Dtwe98lzhb7");

  if(!!data.wvIPAddress) {
    geoIP2URL.searchParams.set('ip', `${data.wvIPAddress || ""}`);
    geoIP2URL.searchParams.set('ipv4', `${data.wvIPAddress || ""}`);
  }

  if(!!cfIPV6) {
    if(!!data.wvIPAddress) {
      geoIP2URL.searchParams.set('ip', `${cfIPV6 || ""}`);
    }
    geoIP2URL.searchParams.set('ipv6', `${cfIPV6 || ""}`);
  }

  geoIP2URL.searchParams.set('format', "json");

  const geoIP2Response = await fetch(geoIP2URL.toString())
    .then(response => response.json()).catch(err => {
      return err.error
    })

  geo2 = ((geoIP2Response)
    && (typeof geoIP2Response === 'object')
    && ('data' in geoIP2Response)
    && (typeof geoIP2Response.data === 'object')
    && ('identity' in geoIP2Response.data)
  ) ? JSON.parse(JSON.stringify(geoIP2Response?.data?.identity || "")) : {};

  data.wvIsHuman = data.wvIsHuman === "" && geo2.hasOwnProperty("is_bot") && geo2.is_bot !== "" ? (Boolean(geo2.is_bot) ? "0" : "1") : data.wvIsHuman ;

  data.wvIsIncognito = (data.wvIsIncognito === "" && 'incognito' in geo1) ? (Boolean(geo1.incognito) ? "1" : "0") : data.wvIsIncognito ;

  data.wvIPAddress = data.wvIPAddress === "" && geo2.hasOwnProperty("ipAddress") && !!geo2.ipAddress ? geo2.ipAddress : data.wvIPAddress ;

  try {
    const opLatitude = document.querySelectorAll(".Current_Location_Latitude");
    if (opLatitude && opLatitude.length > 0 && opLatitude[0]) {
      const tempLat = opLatitude[0]?.value ?? "";
      if(!!tempLat) {
        data.wvLatitude = tempLat;
      }
    }
  } catch(e) {
    e = null;
  }

  data.wvLatitude = data.wvLatitude === "" && geo2.hasOwnProperty("latitude") ? geo2?.latitude?.toString() : data.wvLatitude ;
  data.wvLatitude = (data.wvLatitude === ""
    && 'ipLocation' in geo1
    && typeof geo1.ipLocation === "object"
    && 'latitude' in geo1.ipLocation) ? geo1.ipLocation?.latitude?.toString() : data.wvLatitude ;

  try {
    const opLongitude = document.querySelectorAll(".Current_Location_Longitude");
    if (opLongitude && opLongitude.length > 0 && opLongitude[0]) {
      const tempLon = opLongitude[0]?.value ?? "";
      if(!!tempLon) {
        data.wvLongitude = tempLon;
      }
    }
  } catch(e) {
    e = null;
  }

  data.wvLongitude = data.wvLongitude === "" && geo2.hasOwnProperty("longitude") ? geo2?.longitude?.toString() : data.wvLongitude ;
  data.wvLongitude = (data.wvLongitude === ""
    && 'ipLocation' in geo1
    && typeof geo1.ipLocation === "object"
    && 'latitude' in geo1.ipLocation) ? geo1.ipLocation?.latitude?.toString() : data.wvLongitude ;

  data.wvBrowser = data.wvBrowser === "" && geo2.hasOwnProperty("browser") && !!geo2.browser ? geo2.browser : data.wvBrowser ;
  data.wvOS = data.wvOS === "" && geo2.hasOwnProperty("os") && !!geo2.os ? geo2.os : data.wvOS ;
  data.wvDeviceType = data.wvDeviceType === "" && geo2.hasOwnProperty("deviceType") && !!geo2.deviceType ? geo2.deviceType : data.wvDeviceType ;
  data.wvCity = data.wvCity === "" && geo2.hasOwnProperty("city") && !!geo2.city ? geo2.city : data.wvCity ;
  data.wvContinentCode = data.wvContinentCode === "" && geo2.hasOwnProperty("continentCode") && !!geo2.continentCode ? geo2.continentCode : data.wvContinentCode ;
  data.wvContinentName = data.wvContinentName === "" && geo2.hasOwnProperty("continentName") && !!geo2.continentName ? geo2.continentName : data.wvContinentName ;
  data.wvCountryCode = data.wvCountryCode === "" && geo2.hasOwnProperty("countryCode") && !!geo2.countryCode ? geo2.countryCode : data.wvCountryCode ;
  data.wvCountryName = data.wvCountryName === "" && geo2.hasOwnProperty("countryName") && !!geo2.countryName ? geo2.countryName : data.wvCountryName ;
  data.wvDMACode = data.wvDMACode === "" && geo2.hasOwnProperty("dmaCode") && !!geo2.dmaCode ? geo2.dmaCode : data.wvDMACode ;
  data.wvRegion = data.wvRegion === "" && geo2.hasOwnProperty("region") && !!geo2.region ? geo2.region : data.wvRegion ;
  data.wvRegionCode = data.wvRegionCode === "" && geo2.hasOwnProperty("regionCode") && !!geo2.regionCode ? geo2.regionCode : data.wvRegionCode ;
  data.wvRegionName = data.wvRegionName === "" && geo2.hasOwnProperty("regionName") && !!geo2.regionName ? geo2.regionName : data.wvRegionName ;

  data.wvTimezone = data.wvTimezone === "" && geo2.hasOwnProperty("timezone") && !!geo2.timezone ? geo2.timezone : data.wvTimezone ;
  data.wvTimezone = (data.wvTimezone === ""
    && 'ipLocation' in geo1
    && typeof geo1.ipLocation === "object"
    && 'timezone' in geo1.ipLocation) ? geo1.ipLocation.timezone : data.wvTimezone ;

  let geo1Encoded = "" ;
  try {
    geo1Encoded = base64_encode(JSON.stringify(geo1));
  } catch(e) {
    e = null;
  }

  let geo2Encoded = "" ;
  try {
    geo2Encoded = base64_encode(JSON.stringify(geo2));
  } catch(e) {
    e = null;
  }

  appendInputToContactForm("WV_URL", `${window.location.href}`)
  appendInputToContactForm("WV_GEO1", `${geo1Encoded}`)

  const visitURL = "https://us-central1-utilities-558.cloudfunctions.net/website_visit";
  const visitHeaders = { "Content-Type": "application/json" };
  const visitData = {
    "message": {
      "key": "Fcy2DxHghrQMk8Xv0OQ5K0iUMSwN1f1IogjSz",
      "FO": data.vFingerprintOne,
      "FT": data.vFingerprintTwo,
      "DN": data.wvDomainName,
      "UP": data.wvURIPath,
      "UL": data.wvURL,
      "TPN": data.wvToPhoneNum,
      "PNS": data.wvPhoneNums,
      "IH": data.wvIsHuman,
      "II": data.wvIsIncognito,
      "DT": data.wvDeviceType,
      "BR": data.wvBrowser,
      "OS": data.wvOS,
      "IA": data.wvIPAddress,
      "LAT": data.wvLatitude,
      "LON": data.wvLongitude,
      "CTY": data.wvCity,
      "CONTC": data.wvContinentCode,
      "CONTN": data.wvContinentName,
      "COUNTC": data.wvCountryCode,
      "COUNTN": data.wvCountryName,
      "DMAC": data.wvDMACode,
      "RE": data.wvRegion,
      "REC": data.wvRegionCode,
      "REN": data.wvRegionName,
      "TZ": data.wvTimezone,
      "SR": data.src,
      "AT": data.at,
      "ADG": data.adg,
      "OLOC": data.oloc,
      "GC": data.gclid,
      "WB": data.wbraid,
      "GB": data.gbraid,
      "OLA": data.olat,
      "OLO": data.olong,
      "GEO1": geo1Encoded,
      "GEO2": geo2Encoded,
      "CFIP": cfIPV6,
      "UA": data.wvUA,
      "SWI": data.wvSWI,
      "SHE": data.wvSHE,
    }
  };

  sendFetch(visitURL, "POST", visitHeaders, visitData);

  return {geo1, geo2};
}
